module.exports = __webpack_public_path__ + "static/media/gndu.709ef15c.jpeg";